// This file has helpers for dealing with emojis
import { __ } from 'bits/intl'

const categoryTitles = {
  people: __('Smileys & People'),
  nature: __('Animals & Nature'),
  food: __('Food & Drink'),
  activity: __('Activity'),
  travel: __('Travel & Places'),
  objects: __('Objects'),
  symbols: __('Symbols'),
  flags: __('Flags'),
}

// TODO: pick better icons so that they have same vertical alignment
const categoryIcons = {
  people: 'mood',
  nature: 'cat',
  food: 'restaurant',
  activity: 'basketball',
  travel: 'directions_car',
  objects: 'lightbulb',
  symbols: 'favorite',
  flags: 'flag',
}

const FROZEN_FACE_ICON = {
  iconSrc: 'https://padlet.net/icons/6.6/svg/1f976.svg',
  iconAlt: __('Frozen face'),
}

export { categoryTitles, categoryIcons, FROZEN_FACE_ICON }
